//react-components
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

//Component
import Login from "./Login";

//Custom UI Components
import UserNotification from "../CustomUIComponents/UserNotification/UserNotification";
import LoadingModal from "../CustomUIComponents/LoadingModal/LoadingModal";

//Constants
import { APPLICATION_CONFIGURATIONS } from "../Utils/ApplicationConfigurations";
import { API_RESPONSE_STATUS_CODES } from "../Utils/Constants";

//Actions
import { loginAction, forgotPasswordAction } from "./LoginAction";

//Styles
import "./Login.scss";
import { Strings } from "../Translations/i18n";

class LoginContainer extends Component {
  constructor() {
    super();
    this.state = {
      errorMessage: "",
      toShowToast: false,
      message: "",
      level: "",
      title: "",
      showLoadingModal: false,
    };
  }

  handleLogin = (username, password) => {
    this.setState(
      {
        errorMessage: "",
        showLoadingModal: true,
      },
      () => {
        this.props.loginAction(username, password, (responseData) => {
          if (responseData.status === API_RESPONSE_STATUS_CODES.SUCCESS) {
            if (responseData.data.isSystemPassword) {
              this.props.history.push(
                APPLICATION_CONFIGURATIONS.path.changePassword
              );
            } else {
              this.props.history.push(
                APPLICATION_CONFIGURATIONS.path.dashboard
              );
            }

            this.setState({
              errorMessage: "",
              showLoadingModal: false,
            });
          } else {
            this.setState({
              showLoadingModal: false,
              errorMessage: Strings("errorInvalidUsernameOrPassword"),
            });
          }
        });
      }
    );
  };

  handleForgotPassword = (username) => {
    this.setState({
      errorMessage: "",
      toShowToast: false,
      message: "",
      level: "",
      title: "",
      showLoadingModal: true,
    });
    forgotPasswordAction(username, this.forgotPasswordCallback);
  };

  forgotPasswordCallback = (response) => {
    if (response.data.status === API_RESPONSE_STATUS_CODES.SUCCESS) {
      this.setState({
        errorMessage: "",
        toShowToast: true,
        message: Strings("emailHasBeenSent"),
        level: "success",
        showLoadingModal: false,
      });
    } else {
      this.setState({
        errorMessage: "",
        toShowToast: true,
        message: Strings("emailHasNotBeenSent"),
        level: "error",
        showLoadingModal: false,
      });
    }
  };

  render() {
    return (
      <span>
        <LoadingModal showLoadingModal={this.state.showLoadingModal} />
        {this.state.toShowToast && (
          <UserNotification
            userNotificationObj={{
              message: this.state.message,
              level: this.state.level,
              title: this.state.level === "success" ? "Success !" : "Error !",
            }}
          />
        )}

        <Login
          handleLogin={this.handleLogin}
          handleForgotPassword={this.handleForgotPassword}
          errorMessage={this.state.errorMessage}
          getOTP={this.getOTP}
        />
      </span>
    );
  }
}

function matchDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      loginAction: loginAction,
      forgotPasswordAction: forgotPasswordAction,
    },
    dispatch
  );
}

export default connect(null, matchDispatchToProps)(LoginContainer);
